import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../../services/redux/types";

export const selectProfileState = (state: RootState) => state.profileState;

export const selectProfile = createSelector(
  selectProfileState,
  (state) => state.profile,
);

export const selectIsProfileFilled = createSelector(
  selectProfile,
  ({ username, usertable }) =>
    Boolean(username.trim() && usertable && usertable.trim()),
);

export const selectIsProfileSkipped = createSelector(
  selectProfile,
  ({ skip }) => skip,
);
